export default __webpack_public_path__ + "static/media/chrismas-challenge-header.43ba07a3.png";